import React, { type FC, type PropsWithChildren } from 'react';

import { SentryConfigured } from './SentryConfigured';

type SentryErrorBoundaryProps = PropsWithChildren<{
  fallbackText: JSX.Element;
}>;

export const SentryErrorBoundary: FC<SentryErrorBoundaryProps> = ({
  fallbackText,
  children,
}) => {
  return (
    <SentryConfigured.ErrorBoundary fallback={fallbackText}>
      {children}
    </SentryConfigured.ErrorBoundary>
  );
};
